<template>
    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#services" @click="$router.push({ name: 'dashboard' })">الخدمات
                </a> </li>
            <li> <span class="divider"> / </span>
                <router-link :to="{ name: 'electronicservices' }">الخدمات الالكترونية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#">شراء استمارة رقم قومي مميكنة</a> </li>
        </template>
    </Path>

    <section v-if="!isReview" id="content">
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label for="basic-url" class="form-label">الاسم رباعي لصاحب البطاقة</label>
                            <div class="input-group mb-3">
                                <div class="row g-3">
                                    <div class="col-6 col-sm">
                                        <input v-model="form.firstName" type="text" class="form-control" id="basic-url1"
                                            aria-describedby="basic-addon3" @blur="v$.form.firstName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.firstName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                    <div class="col-6 col-sm">
                                        <input v-model="form.secondName" type="text" class="form-control"
                                            id="basic-url2" aria-describedby="basic-addon3"
                                            @blur="v$.form.secondName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.secondName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                    <div class="col-6 col-sm">
                                        <input v-model="form.thirdName" type="text" class="form-control" id="basic-url3"
                                            aria-describedby="basic-addon3" @blur="v$.form.thirdName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.thirdName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                    <div class="col-6 col-sm">
                                        <input v-model="form.fourthName" type="text" class="form-control"
                                            id="basic-ur4l" aria-describedby="basic-addon3"
                                            @blur="v$.form.fourthName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.fourthName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="basic-url" class="form-label">الرقم القومى</label>
                            <div class="input-group mb-3">
                                <div class="col-md-12">
                                    <input v-model="form.nid" type="text" class="form-control" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.nid.$touch()">
                                    <p class="data--required" v-for="error of v$.form.nid.$errors" :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-4">
                            <label for="" class="form-label">اسم الام بالكامل </label>
                            <div class="input-group mb-3">
                                <div class="input-group mb-3">
                                    <div class="col-md-12">
                                        <input v-model="form.motherName" type="text" class="form-control "
                                            id="basic-ur4l" aria-describedby="basic-addon3"
                                            @blur="v$.form.motherName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.motherName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="" class="form-label">النوع</label>
                            <div class="input-group mb-3">
                                <div class="col-md-12">
                                    <select v-model="form.gender" class="form-select" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.gender.$touch()">
                                        <option v-for="gender in gender_lookups" :key="gender.Id" :value="gender.Code">
                                            {{ gender.Name }}</option>
                                    </select>
                                    <p class="data--required" v-for="error of v$.form.gender.$errors" :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>

                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="" class="form-label">فئة الاستمارة</label>
                            <div class="input-group mb-3">
                                <div class="col-md-12">
                                    <select v-model="documentType" class="form-select" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.documentType.$touch()">
                                        <option v-for="documenttype in nidFormTypes_lookups" :key="documenttype.Id" :value="documenttype.Code">
                                            {{ documenttype.Name }}</option>
                                    </select>
                                    <p class="data--required" v-for="error of v$.documentType.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row mb-3  mt-3">
                        <div class="col-6 col-md-3 mb-3">
                            <label for="" class="form-label">اجمالى سعر الاستمارة</label>
                        </div>
                        <div class="col-6 col-md-3 mb-3">
                            <input v-model="servicePrice" type="text" readonly="readonly"
                                class="form-control text-center" aria-label="">
                        </div>
                    </div>

                    <div class="row my-9 justify-content-center">
                        <div class="col-12 col-sm-2 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="review_request" type="button"
                                    class="btn btn-nid btn-light mx-3 mt-5 align-self-center">
                                    مراجعة الطلب
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <Review v-if="isReview" @close="toggle_isReview()" :serviceprice="servicePrice" :DocCode="documentType"
        DocType="استمارة بطاقة" :DocData="DocData" :isNid="false" />

</template>


<script>
import validations from "@/shared/validations.js";
import { mapActions, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import Path from "@/components/Path.vue";
import Review from "@/components/Review.vue";
import { ref } from 'vue';
import sharedMethods from "@/shared/sharedMethods";
import sharedData from "@/shared/sharedData";
import { debugLog } from "@/plugins/debug";

export default {
    ...sharedMethods,
    name: 'NidFormView',
    components: { Path, Review },
    data() {
        return {

            v$: useVuelidate(),
            servicePrice: '',

            responseMessage: '',
            responseCode: 200,
            nidFormTypes_lookups: sharedData.NidForm_lookups,
            gender_lookups: [],
            documentType: 'MOICSO112',

            form: {
                firstName: '',
                secondName: '',
                thirdName: '',
                fourthName: '',
                nid: '',
                motherName: '',
                gender: '',
            }
        }
    },
    setup() {
        const isReview = ref(false);
        const toggle_isReview = () => {
            isReview.value = !isReview.value;

        }
        return { isReview, toggle_isReview }
    },

    // validations
    validations() {
        return validations.NidForm
    },

    created() {
        // reset after refersh or reloading page
        this.resetDocs();  // store action for resetting number of requests in store to 0
        setTimeout(() => {
            sharedMethods.get_servicePrice("nidFormPrice",this.documentType).then(res => { this.servicePrice = res; });
            sharedMethods.get_genders().then(res => { this.gender_lookups = res; });
        }, 200);

        window.scrollTo({ top: 0, behavior: "smooth" });
        // this.AutoFill();
    },
    watch: {
        documentType(DocumentTypeCode) {
            sharedMethods.get_servicePrice("nidFormPrice",DocumentTypeCode).then(res=>{this.servicePrice = res;});
        }
    },

    computed: {
        ...mapGetters({ nidForm: "StateDocs", options: "StateOptions", contactInfo: "StateContact" }),

        DocData() {
            return {
                "nidForm": Object.values(this.nidForm),
                ...this.contactInfo
            }
        }
    },

    methods: {
        ...mapActions(["saveDocs", "resetDocs", "deleteDoc"]),

        async review_request() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store                      
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {

                    debugLog('Docs:', Object.values(this.nidForm)); 
                    this.isReview = true;
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }

            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },


        //auto fill for testing
        AutoFill() {
            this.form.firstName = "تسنيم";
            this.form.secondName = "سمير";
            this.form.thirdName = "محمد";
            this.form.fourthName = "شحاتة";
            this.form.motherName = "ماما";
            this.form.nid = "29709011235741";
            this.form.gender = 'F';
        },


        // assign data to variables and save it to the store
        saveDocument() {
            let docData = {
                "name": { "fullName": this.form.firstName + ' ' + this.form.secondName + ' ' + this.form.thirdName + ' ' + this.form.fourthName },
                "motherFullName": this.form.motherName,
                "nid": { "nationalIdenNumber": this.form.nid },
                "DocumentTypeCode": this.documentType,
                "genderCode": this.form.gender,
                "numberOfCopies": 1,
                "relationCode": "SELF"
            }
            let savedata = {
                // "reqNo": this.docRequests.requestNo,
                "document": docData,
            }


            this.saveDocs(savedata);  // store action for saving requests

        },

        // empty form data to fill new one
        reset() {
            this.form = {};
            this.gender = '',
            this.documentType= 'MOICSO112'
            this.v$.$reset();
        }
    }
}
</script>